// Pure helper: coerce whatever react-query hands the venue home into a
// well-formed { events, closingTimes } pair. Guards two prod-hit cases:
//
//   1. Legacy cache collision — before 2026-09-07 the venue home and the
//      /events page shared queryKey `["events", venueId]` but returned
//      different shapes (wrapped object vs unwrapped array). Navigating
//      /events → / handed the home the array, and its `.find()` threw
//      "undefined is not an object (evaluating 'pe.find')" on Love Inn
//      prod.
//   2. Any downstream refactor that changes the query shape without
//      updating every consumer.
//
// The queryKey collision is fixed at the call site (distinct keys); this
// helper is belt-and-braces so a repeat regression can't white-screen
// the whole home again.

import type { EventSummary, VenueClosingTimes } from "./types";

export function normaliseEventsResponse(data: unknown): {
  events: EventSummary[];
  closingTimes: VenueClosingTimes | undefined;
} {
  if (Array.isArray(data)) {
    return { events: data as EventSummary[], closingTimes: undefined };
  }
  if (data && typeof data === "object") {
    const obj = data as { events?: unknown; closingTimes?: VenueClosingTimes };
    const events = Array.isArray(obj.events) ? (obj.events as EventSummary[]) : [];
    return { events, closingTimes: obj.closingTimes };
  }
  return { events: [], closingTimes: undefined };
}
